import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './components/common/Home/HomePage';
import config from '../src/components/config/config';
import Main from './components/landing/Main';
import { split } from 'lodash';
import '../src/styles/global.scss';
import HomePageRelator from './components/relator/HomePageRelator';
import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import { useGAEventsTracker } from './util/gtag';
import OfferMessage from './components/common/PPG_Offer/PPG_Offer_status';
import DocusignOTP from './components/common/Docusigns_otp/Docusigns_otp';
import { Redirect } from 'react-router';
import Calqulator from './components/common/Calqulator/Calqulator';
import NewHomePage from './components/common/Home/NewHomePage';
import ApplicationFunnel from './components/common/ApplicationFunnelWidget/ApplicationFunnel';

var time = null;
var time2 = null;
var timefinish = null;
var timer;

export default function RouterComponent(props) {
  ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_UA_KEY}`)
  ReactGA4.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_GA4_KEY}`)
  const [partner, setPartner] = useState([])
  const GAEventTracker = useGAEventsTracker(window.location.origin)
  const GAEventTrackerTimer = useGAEventsTracker(window.location.origin + window.location.pathname + "Questionnaire");
  const [efficientDefault, setEfficientDefault] = useState(false)
  const [user, setUser] = useState(false)
  const [isSet, setIsSet] = React.useState(false)
  const [loader, setLoader] = useState(false)
  const [loaderOpen, setLoaderOpen] = useState(false)
  const location = window.location;
  const [faqRealEstateAgentOpen, setFaqRealEstateAgentOpen] = useState("false")
  const [pressReleaseResponse, setPressReleaseResponse] = useState(null)
  var realEstateAgentValue = null;
  const url = window.location.href;
  const urlName = new URL(url);
  const urlNamePath = split(urlName.pathname, "/")
  const userDetail = urlNamePath[2] && urlNamePath[2].toLowerCase()
  const host = window.location.host;
  const OLD_TEMPLATE_DOMAIN_PATH=process.env.REACT_APP_MICROSITE_OLD_TEMPLATE_FULL_DOMAIN_PATH 
  const NEW_TEMPLATE_DOMAIN_PATH=process.env.REACT_APP_MICROSITE_NEW_TEMPLATE_FULL_DOMAIN_PATH
  const OLD_TEMPLATE_DOMAIN_WWW_PATH = process.env.REACT_APP_MICROSITE_OLD_TEMPLATE_WWW_DOMAIN_PATH

  const GAtimer = () => {
    let trackEvent = null;
    const date = new Date().getTime()
    if (!time) {
      trackEvent = time = date;
      return
    } else {
      const diff = date - time;
      const submit = Math.floor(diff / 1000) //in seconds
      GAEventTrackerTimer("Eligibility Submit in seconds", parseInt(submit))
    }
  }
  const GAtimerFinish = () => {
    const dateFinish = new Date().getTime()
    if (!timefinish) {
      timefinish = dateFinish;
      return
    } else {
      const diff = dateFinish - time;
      const submitFinish = Math.floor(diff / 1000) //in seconds
      GAEventTrackerTimer("Finish Submit in seconds", parseInt(submitFinish))
    }
  }
  const timer2 = (urlvalue) => {
    const date = new Date().getTime()
    if (!time2) {
      time2 = date;
      return
    } else {
      const diff = date - time2;
      const minDiff = diff / 60 / 1000; //in minutes
      const hDiff = diff / 3600 / 1000; //in hours 
      const submit = Math.floor(((diff / 1000) % 60)) //in seconds
      ReactGA.event({ action: window.location.origin + urlvalue.pathname + "/Timer spent on page", value: parseFloat(hDiff).toFixed(0) + "hh" + ":" + parseFloat(minDiff).toFixed(0) + "mm" + ":" + submit + "ss" });
      ReactGA4.event({ action: window.location.origin + urlvalue.pathname + "/Timer spent on page", value: parseFloat(hDiff).toFixed(0) + "hh" + ":" + parseFloat(minDiff).toFixed(0) + "mm" + ":" + submit + "ss" });
      time2 = null;
    }
  }
  const handleEfficientDefault = () => {
    setEfficientDefault(!efficientDefault)
  }

  useEffect(() => {
    if (urlNamePath[1] && urlNamePath[1].toLowerCase() !== partner.url_path) {
      setLoader(false)
    }
    if ((urlNamePath[1] && urlNamePath[1].toLowerCase() === partner.url_path) || (userDetail === props.pathname) || ((urlNamePath[1] && urlNamePath[1] === partner.url_path) || (urlNamePath[2] && urlNamePath[2] === partner.url_path))) {
      setLoader(true)
    }
    if (userDetail === "jeremy" || userDetail === "peter" || userDetail === "chandra" || userDetail === "jim" || userDetail === "megan" || userDetail === "dori" || userDetail === "marty" || userDetail === "don" || userDetail === "david") {
      setUser(true)
    }
  })

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA4.pageview(window.location.pathname + window.location.search);
  }, [])

  useEffect(() => {
    if (urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "" && urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "docusign-redirect-url" && urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "docusign-verification-code" && (urlNamePath[1]?.toLowerCase() !== "calculator" && urlNamePath[2]?.toLowerCase() !== "calculator") && urlNamePath[1]?.toLowerCase() !== "builder-calculator" && urlNamePath[1]?.toLowerCase() !== "questionnaire")
      fetch(`${config.baseUrlCP}get-partner?name=${props?.pathname === 'jw&!$329654' ? encodeURIComponent(props?.pathname) : props?.pathname.toLowerCase()}`,
        {
          headers: {
            "Authorization": `${process.env.REACT_APP_API_KEY}`,
            'Accept-Encoding': 'gzip, deflate',
          }
        })
        .then(async response => {
          const result = await response.json()
          if (response.status === 201 || response.status === 200) {
            setPartner(result)
            setIsSet(true)
          }
          else if (response.status === 404) {
            setTimeout(() => {
              if(urlNamePath[1] !== 'jw&!$329654'){
                if (urlNamePath[1] && urlNamePath[1].toLowerCase() !== "") {
                  if (userDetail !== partner.url_path && urlNamePath[1] && urlNamePath[1].toLowerCase() !== "docusign-redirect-url" && urlNamePath[1] && urlNamePath[1].toLowerCase() !== "docusign-verification-code" && urlNamePath[1].toLowerCase() !== "calculator" && urlNamePath[1].toLowerCase() !== "builder-calculator" && urlNamePath[1].toLowerCase() !== "questionnaire") {
                    window.location.replace("/");
                  } else if (urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== partner?.url_path && urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "docusign-redirect-url" && urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "docusign-verification-code" && urlNamePath[1]?.toLowerCase() !== "calculator" && urlNamePath[1]?.toLowerCase() !== "builder-calculator" && urlNamePath[1].toLowerCase() !== "questionnaire") {
                    window.location.replace('/')
                  }
                }
              }
            }, 1000);
          }
        }
        )
        .catch((error) => {
          console.error('error message', error)
        })
  }, [])

  useEffect(() => {
    if (urlName && urlName.hash === "#faq") {
      setTimeout(() => {
        let ele = document.getElementById("faq")
        if (ele) {
          ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
        }
      }, 1000);
    }
  }, [])

  useEffect(() => {
    if(host === OLD_TEMPLATE_DOMAIN_PATH || host === OLD_TEMPLATE_DOMAIN_WWW_PATH) {
      if (urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "" && urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "docusign-redirect-url" && urlNamePath[1] && urlNamePath[1]?.toLowerCase() !== "docusign-verification-code" && urlNamePath[1]?.toLowerCase() !== "calculator" && urlNamePath[1]?.toLowerCase() !== "builder-calculator" && urlNamePath[1].toLowerCase() !== "questionnaire") {
        if (urlNamePath[1] && urlNamePath[1].toLowerCase() === partner.url_path) {
          if (partner?.calque_partner_type === 1) {
            window.location.replace('/lender/' + `${partner?.url_path}`)
          } else if (partner?.calque_partner_type === 2) {
            window.location.replace('/realtor/' + `${partner?.url_path}`)
          } else if (partner?.calque_partner_type === 3) {
            window.location.replace('/builder/' + `${partner?.url_path}`)
          }
        }
        if ((urlNamePath[1] && urlNamePath[1].toLowerCase() === "lender" && userDetail == null) || (urlNamePath[1] && urlNamePath[1].toLowerCase() === "realtor" && userDetail == null) || (urlNamePath[1] && urlNamePath[1].toLowerCase() === "builder" && userDetail == null) || (urlNamePath[1] && urlNamePath[1].toLowerCase() !== "lender" && urlNamePath[1] && urlNamePath[1].toLowerCase() !== "realtor" && urlNamePath[1] && urlNamePath[1].toLowerCase() !== "builder" && urlNamePath[1].toLowerCase() !== "lending-partner" && urlNamePath[1].toLowerCase() !== "agent-partner" && userDetail != null)) {
          window.location.replace('/')
        }
        if ((urlNamePath[1] && urlNamePath[1].toLowerCase() === "lender" && ((partner?.calque_partner_type !== 1 && partner?.calque_partner_type === 2) || (partner?.calque_partner_type !== 1 && partner?.calque_partner_type === 3)))) {
          window.location.replace('/')
        } else if ((urlNamePath[1] && urlNamePath[1].toLowerCase() === "realtor" && ((partner?.calque_partner_type !== 2 && partner?.calque_partner_type === 1) || (partner?.calque_partner_type !== 2 && partner?.calque_partner_type === 3)))) {
          window.location.replace('/')
        } else if ((urlNamePath[1] && urlNamePath[1].toLowerCase() === "builder" && ((partner?.calque_partner_type !== 3 && partner?.calque_partner_type == 1) || (partner?.calque_partner_type !== 3 && partner?.calque_partner_type === 2)))) {
          window.location.replace('/')
        }
      }
    }
  }, [partner?.calque_partner_type])

  useEffect(() => {
    if (location) {
      var path = location.pathname;
      var route = path.split("/lender/");
      if (route.length > 0) {
        route.map((e) => {
          if (e !== "") {
            const lc = e.toLowerCase();
            path = path.replaceAll(e, lc);
          }
        });
        if (path !== location.pathname) {
          window.location.href = location.origin + path
        }
      }
    }
  }, [location])

  useEffect(() => {
    const lastPathSegment = urlNamePath[urlNamePath.length - 1]; 
    if (partner?.use_old_template === true && partner?.use_new_template === true) {
      return; 
    } 
    // Redirecting users based on domain and their respective template
    if(partner?.use_old_template === true && partner?.use_new_template === false) {
      if(host === NEW_TEMPLATE_DOMAIN_PATH) {
        const newUrl = window.location.href.replace(`${NEW_TEMPLATE_DOMAIN_PATH}${window.location.pathname}`, `${OLD_TEMPLATE_DOMAIN_PATH}/${lastPathSegment}`);
        window.location.href = newUrl; // Redirect to new URL
      }
    } else if(partner?.use_new_template === true && partner?.use_old_template === false) {
      if(host === OLD_TEMPLATE_DOMAIN_PATH) {
        const newUrl = window.location.href.replace(`${OLD_TEMPLATE_DOMAIN_PATH}${window.location.pathname}`,`${NEW_TEMPLATE_DOMAIN_PATH}/${lastPathSegment}`);
        window.location.href = newUrl; // Redirect to new URL
      }
      if(host === OLD_TEMPLATE_DOMAIN_WWW_PATH) {
        const newUrl = window.location.href.replace(`${OLD_TEMPLATE_DOMAIN_WWW_PATH}${window.location.pathname}`,`${NEW_TEMPLATE_DOMAIN_PATH}/${lastPathSegment}`);
        window.location.href = newUrl; // Redirect to new URL
      }
    } 
  }, [partner])

  return (
    <Router>
      <Switch>
        <Route path="/" component={() => <Main GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} setFaqRealEstateAgentOpen={setFaqRealEstateAgentOpen} setPressReleaseResponse={setPressReleaseResponse} calendlyMain={props.calendlyMain} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} addressGlobal={props.addressGlobal} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList} click_id={props.click_id} gclid={props.gclid} linked_in={props.linked_in} lead_activity_id={props.lead_activity_id} facebook_pixel={props.facebook_pixel} />} exact={true} />
        <Route path={'/builder-calculator'} component={() => <Calqulator />} />
        <Route path={`/questionnaire`} component={() => <ApplicationFunnel />} />
        <Route path="/docusign-redirect-url" component={OfferMessage} />
        <Route path='/docusign-verification-code' component={DocusignOTP} />
        {/* {
        partner?.calque_partner_type === 1 ?
        <Route path={`/lender/${props?.pathname.toLowerCase()}/calculator`} component={() => <Calqulator />} />
        :
        partner?.calque_partner_type === 2 ?
        <Route path={`/realtor/${props?.pathname.toLowerCase()}/calculator`} component={() => <Calqulator />} />
        :
        partner?.calque_partner_type === 3 ?
        <Route path={`/builder/${props?.pathname.toLowerCase()}/calculator`} component={() => <Calqulator />} />
        :
        <Route path={'/calculator'} component={() => <Calqulator />} />
        } */}
        {/* {( host === OLD_TEMPLATE_DOMAIN_PATH || host === OLD_TEMPLATE_DOMAIN_WWW_PATH) && 
          partner?.calque_partner_type === 1 ?
            <Route path={`/lender/${props?.pathname.toLowerCase()}/questionnaire`} component={() => <ApplicationFunnel />} />
          : partner?.calque_partner_type === 2 ?
            <Route path={`/realtor/${props?.pathname.toLowerCase()}/questionnaire`} component={() => <ApplicationFunnel />} />
          : partner?.calque_partner_type === 3 ?
            <Route path={`/builder/${props?.pathname.toLowerCase()}/questionnaire`} component={() => <ApplicationFunnel />} />
          : null
        }
        {
          host === NEW_TEMPLATE_DOMAIN_PATH &&
          <Route path={`/${props?.pathname.toLowerCase()}/questionnaire`} component={() => <ApplicationFunnel />} />
        } */}
        <Route path="/questionnaire" component={ApplicationFunnel} />
        <Route path="/lender/:partnerPath/questionnaire" component={ApplicationFunnel} />
        <Route path="/realtor/:partnerPath/questionnaire" component={ApplicationFunnel} />
        <Route path="/builder/:partnerPath/questionnaire" component={ApplicationFunnel} />
        <Route path="/:partnerPath/questionnaire" component={ApplicationFunnel} />
        <Route path="/calculator" component={Calqulator} />
        <Route path="/:partnerPath/calculator" component={Calqulator} />
        <Route path="/lender/:partnerPath/calculator" component={Calqulator} />
        <Route path="/realtor/:partnerPath/calculator" component={Calqulator} />
        <Route path="/builder/:partnerPath/calculator" component={Calqulator} />
        { 
          // Conditional based routing for templates based on host
          loader === true ?
            partner?.calque_partner_type === 1 ?
            host === NEW_TEMPLATE_DOMAIN_PATH ? 
              <Route path={`/${props?.pathname.toLowerCase()}`} component={() => <NewHomePage {...props} pathname={partner} partner={partner} efficientDefault={efficientDefault} setEfficientDefault={setEfficientDefault} handleEfficientDefault={handleEfficientDefault} GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>} /> :
              <Route path={`/lender/${props?.pathname.toLowerCase()}`} component={() => <HomePage {...props} pathname={partner} partner={partner} efficientDefault={efficientDefault} setEfficientDefault={setEfficientDefault} handleEfficientDefault={handleEfficientDefault} GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>} /> 
              :
              partner?.calque_partner_type === 2 ?
              <div>
                {host === NEW_TEMPLATE_DOMAIN_PATH ? <Route path={`/${props?.pathname === 'jw&!$329654' ?  decodeURIComponent('jw&!$329654') : props?.pathname.toLowerCase()}`} component={() => <NewHomePage {...props} pathname={partner} partner={partner} efficientDefault={efficientDefault} setEfficientDefault={setEfficientDefault} handleEfficientDefault={handleEfficientDefault} GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} partnerContactRole={props.partnerContactRole} condition={props.condition}/>} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/> :
                <Route path={`/realtor/${props?.pathname === 'jw&!$329654' ?  decodeURIComponent('jw&!$329654') : props?.pathname.toLowerCase()}`} component={() => <HomePageRelator {...props} pathname={partner} partner={partner} efficientDefault={efficientDefault} setEfficientDefault={setEfficientDefault} handleEfficientDefault={handleEfficientDefault} GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} partnerContactRole={props.partnerContactRole} condition={props.condition}/>} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>}
                
              </div>
              :
              partner?.calque_partner_type === 3 ?
              <div>
                {host === NEW_TEMPLATE_DOMAIN_PATH ? <Route path={`/${props?.pathname.toLowerCase()}`} component={() => <NewHomePage {...props} pathname={partner} partner={partner} efficientDefault={efficientDefault} setEfficientDefault={setEfficientDefault} handleEfficientDefault={handleEfficientDefault} GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>}/> :
                <Route path={`/builder/${props?.pathname.toLowerCase()}`} component={() => <HomePage {...props} pathname={partner} partner={partner} efficientDefault={efficientDefault} setEfficientDefault={setEfficientDefault} handleEfficientDefault={handleEfficientDefault} GAtimer={GAtimer} GAtimerFinish={GAtimerFinish} timer2={timer2} timer={timer} GAEventTracker={GAEventTracker} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>}/>}
              </div>
              :
                <div className='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                  <div style={{ width: '175px' }}>
                    <img src="/assets/logos/Color_H.png" alt="Logo" width="150" height="60px" style={{ objectFit: 'contain' }}></img>
                  </div>
                  <div>
                    <div className="snippet" data-title=".dot-flashing">
                      <div className="stage">
                        <div className="dot-flashing mt-2"></div>
                      </div>
                    </div>
                  </div>
                </div>
            :
            <div className='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
              <div style={{ width: '175px' }}>
                <img src="/assets/logos/Color_H.png" alt="Logo" width="150" height="60px" style={{ objectFit: 'contain' }}></img>
              </div>
              <div>
                <div className="snippet" data-title=".dot-flashing">
                  <div className="stage">
                    <div className="dot-flashing mt-2"></div>
                  </div>
                </div>
              </div>
            </div>
        }
        {
          loader !== true &&
          <Route path="*">
            <Redirect to="/" />
          </Route>
        }
      </Switch>
    </Router>
  )
}